import { render, staticRenderFns } from "./GlobalFooter.vue?vue&type=template&id=672120f3&scoped=true"
import script from "./GlobalFooter.vue?vue&type=script&lang=js"
export * from "./GlobalFooter.vue?vue&type=script&lang=js"
import style0 from "./GlobalFooter.vue?vue&type=style&index=0&id=672120f3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672120f3",
  null
  
)

export default component.exports